import { useRef, useState, useEffect } from "react";
import { FaSpinner } from "react-icons/fa";

const CameraComponent = ({ handleCameraModalClose, setSelectedFile }) => {
    const videoRef = useRef(null);
    const streamRef = useRef(null); // store the MediaStream
    const canvasRef = useRef(null);
    const [photo, setPhoto] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        openCamera();
    }, [])

    const handleRetakePhoto = () => {
        // Clear the captured photo
        setPhoto(null);

        // Clear the video stream
        if (streamRef.current) {
            streamRef.current.getTracks().forEach(track => track.stop());
            streamRef.current = null;
        }

        // Clear video element
        if (videoRef.current) {
            videoRef.current.srcObject = null;
        }

        // Clear canvas content (optional)
        if (canvasRef.current) {
            const context = canvasRef.current.getContext("2d");
            context && context.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        }

        // Optionally reopen camera if you want to start preview again immediately
        openCamera();
    };

    const takePhoto = () => {
        const context = canvasRef.current.getContext("2d");
        context.drawImage(videoRef.current, 0, 0, 320, 240);
        const imageData = canvasRef.current.toDataURL("image/png");
        setPhoto(imageData);
    };

    const openCamera = async () => {
        setLoading(true);

        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            streamRef.current = stream; // save stream so we can stop it later
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            }
        } catch (err) {
            alert("Camera access denied or not available.");
            closeCamera();
            handleCameraModalClose();
        } finally {
            setLoading(false);
        }
    };

    const closeCamera = () => {
        if (streamRef.current) {
            streamRef.current.getTracks().forEach(track => track.stop()); // stop all tracks
            streamRef.current = null;
        }

        if (videoRef.current) {
            videoRef.current.srcObject = null; // clear video
        }
    };

    const handleUploadPhoto = () => {
        if (!photo) return;

        // Convert base64 to File object
        const byteString = atob(photo.split(',')[1]);
        const mimeString = photo.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        const blob = new Blob([ab], { type: mimeString });
        const file = new File([blob], "captured_photo.jpg", { type: mimeString });

        // Simulate file input selection
        setSelectedFile(file);
        handleCameraModalClose(file);
        closeCamera();
    };

    return (
        <div className="modal-backdrop">
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-md" role="document">
                    <div className="modal-content">
                        <div className="modal-header p-2">
                            <h5 className="modal-title">Click Picture</h5>
                            <button type="button" className="btn-close" onClick={() => { handleCameraModalClose(); closeCamera(); }}></button>
                        </div>
                        <div className="modal-body">
                        {loading && (
                        <div
                            className="d-flex flex-column justify-content-center align-items-center"
                            style={{ height: '240' }} // adjust as per your modal height
                        >
                            <FaSpinner className="fa-spin" style={{ fontSize: '3rem', color: '#00984A' }} />
                            <div className="mt-3 fs-5 text-secondary">Loading camera...</div>
                        </div>
                        )}
                        <canvas ref={canvasRef} width="320" height="240" style={{ display: "none" }} />
                        {!photo ? (
                            <div>
                                <video ref={videoRef} autoPlay style={{ width: "100%", height: "auto", transform: 'scaleX(-1)' }} />
                            </div>
                        ) : (
                            <div>
                                <img src={photo} alt="Captured" style={{ width: "100%", height: "auto", transform: 'scaleX(-1)' }} />
                            </div>
                        )}
                        </div>

                        <div className="modal-footer p-1">
                            {photo ? (
                                <button
                                type="button"
                                className="btn custom-sumbitbtn"
                                onClick={() => { handleUploadPhoto();}}
                            >
                               <div>Ok</div>
                            </button>
                            ) : (
                                <button
                                type="button"
                                className="btn custom-sumbitbtn"
                                onClick={takePhoto}
                                disabled={loading} // Added by Shubham
                                >
                                    Capture
                                </button>
                            )}


                            {photo ? (
                                <button type="button" className="btn btn-danger" onClick={() => { handleRetakePhoto(); }}>
                                    Retake
                                </button>
                            ) : (
                                <button type="button" className="btn btn-danger" onClick={() => { handleCameraModalClose(); closeCamera(); }}>
                                    Close
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CameraComponent